module.exports = __webpack_public_path__ + "img/logo-ylkj.05320cc4.jpg";